import { PageLinkComponentProps } from "@omni/ui/components/PageLink/pageLink.props";

const rewriteAccountLinksForSoftLogin = (
    isLoggedIn: boolean,
    links?: Array<PageLinkComponentProps>,
    loginPage?: string
): Array<PageLinkComponentProps> | undefined => {
    if (!loginPage || isLoggedIn) return links;

    return links?.map((link) => {
        return {
            ...link,
            link: loginPage
        };
    });
};

export { rewriteAccountLinksForSoftLogin };
